import { Fragment, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { Nav, NavDropdown, NavItem, NavLink } from "react-bootstrap";
import TeamPic from "../../assets/team.png";
import Logo from "../../assets/header-logo.png";
import defaultUserAvatar from "../../assets/user-avatar.jpg";
import "./header.styles.scss";
import { SiteContext } from "../../contexts/site-context";
const HeaderAuth = () => {
  const { siteSettings } = useContext(SiteContext);
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const { token, user, logout } = AuthUser();
  const logoutUser = () => {
    if (token !== undefined) {
      logout();
    }
  };

  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  return (
    <Fragment>
      <header
        className={`header-nav menu_style_home_one style2 home10 navbar-scrolltofixed stricky main-menu ${
          splitLocation[1] === "property" && splitLocation[2] !== ""
            ? "listing_single_page5"
            : ""
        }`}
      >
        <div className="container p0">
          <Nav>
            <div className="menu-toggle">
              <div className="menubar-wrapper">
                <button
                  type="button"
                  id="menu-btn"
                  onClick={() => {
                    setIsNavExpanded(!isNavExpanded);
                  }}
                >
                  <span></span>
                </button>
                <Link to="/" className="navbar_brand float-left db-xsd">
                  <img
                    className="logo img-fluid"
                    src={
                      siteSettings && siteSettings.general_info.logo
                        ? siteSettings.general_info.logo
                        : Logo
                    }
                    alt="CentralTx"
                  />
                  <span>CentralTX</span>
                </Link>
                <NavDropdown
                  className="profile-nav-dropdown-menu"
                  title={
                    <div className="pull-left">
                      <img
                        className="header-profile-thumb"
                        src={TeamPic}
                        alt="user pic"
                      />
                      Shailesh
                    </div>
                  }
                  id="profile-nav-dropdown"
                >
                  <NavItem>
                    <NavLink href="/profile">Profile</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink onClick={logoutUser}>
                      <i className="fa fa-sign-out"></i> Logout
                    </NavLink>
                  </NavItem>
                </NavDropdown>
              </div>
            </div>
            <Link to="/" className="navbar_brand float-left dn-xsd">
              <img
                className="logo img-fluid"
                src={
                  siteSettings && siteSettings.general_info.logo
                    ? siteSettings.general_info.logo
                    : Logo
                }
                alt="CentralTx"
              />
              <span>CentralTX</span>
            </Link>
            <ul
              id="respMenu"
              className={
                isNavExpanded
                  ? "ace-responsive-menu text-left expanded"
                  : "ace-responsive-menu text-left"
              }
              data-menu-style="horizontal"
            >
              <li className={splitLocation[1] === "" ? "active" : ""}>
                <Link to="/" onClick={() => setIsNavExpanded(false)}>
                  <span className="title">Home</span>
                </Link>
              </li>
              <li className={splitLocation[1] === "about" ? "active" : ""}>
                <Link to="/about" onClick={() => setIsNavExpanded(false)}>
                  <span className="title">About</span>
                </Link>
              </li>
              <li className={splitLocation[1] === "property" ? "active" : ""}>
                <Link to="/property" onClick={() => setIsNavExpanded(false)}>
                  <span className="title">Property</span>
                </Link>
              </li>
              <li className={splitLocation[1] === "team" ? "active" : ""}>
                <Link to="/team" onClick={() => setIsNavExpanded(false)}>
                  <span className="title">Team</span>
                </Link>
              </li>
              <li
                className={
                  splitLocation[1] === "contact" ? "last active" : "last"
                }
              >
                <Link to="/contact" onClick={() => setIsNavExpanded(false)}>
                  <span className="title">Contact</span>
                </Link>
              </li>
              <li className="list-inline-item list_s float-right dn-xsd">
                <NavDropdown
                  className="profile-nav-dropdown-menu"
                  title={
                    <div className="pull-left">
                      <img
                        className="header-profile-thumb"
                        src={user.photo ? user.photo : defaultUserAvatar}
                        alt="user pic"
                      />
                      {user.name}
                    </div>
                  }
                  id="profile-nav-dropdown"
                >
                  <NavItem>
                    <NavLink href="/profile">My Profile</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="/my-inquiry">My Inquiry</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink onClick={logoutUser}>
                      <i className="fa fa-sign-out"></i> Logout
                    </NavLink>
                  </NavItem>
                </NavDropdown>
              </li>
            </ul>
          </Nav>
        </div>
      </header>
    </Fragment>
  );
};

export default HeaderAuth;
